// extracted by mini-css-extract-plugin
export var actions = "_6a-8";
export var arrow = "_6a-5";
export var card = "_6a-0";
export var cardWrapper = "_6a-9";
export var fieldName = "_6a-3";
export var newValue = "_6a-6";
export var oldValue = "_6a-4";
export var orangeGlowFade = "_6a-c";
export var productSection = "_6a-1";
export var scrollToBottom = "_6a-b";
export var scrollToBottomAnchor = "_6a-a";
export var scrollToBottomIcon = "_6a-d";
export var showAllButton = "_6a-7";
export var table = "_6a-2";